import { Hourglass } from 'lucide-react';

const FormEnergyDimensionsAnalyticsComingSoon = () => {
	return (
		<div className="flex w-full flex-1 flex-col items-center justify-center">
			<div className="relative flex w-full flex-1 flex-col items-center justify-center overflow-hidden rounded-[2rem] border border-zinc-200/80 bg-white px-6 py-16 shadow-sm sm:px-12 sm:py-20 md:px-16 md:py-24">
				<div
					className="pointer-events-none absolute -right-24 -top-24 h-64 w-64 rounded-full bg-brand-orange/10 blur-3xl"
					aria-hidden
				/>
				<div
					className="pointer-events-none absolute -bottom-28 -left-20 h-72 w-72 rounded-full bg-amber-200/30 blur-3xl"
					aria-hidden
				/>

				<div className="relative mx-auto flex max-w-2xl flex-col items-center text-center">
					<div
						className="relative flex h-20 w-20 items-center justify-center rounded-3xl bg-brand-orange/10 ring-1 ring-brand-orange/30"
						aria-hidden
					>
						<span className="absolute inset-0 rounded-3xl bg-brand-orange/15 motion-safe:animate-ping" />
						<Hourglass
							className="relative h-10 w-10 text-brand-orange"
							strokeWidth={2}
						/>
					</div>

					<span className="mt-6 inline-flex items-center gap-2 rounded-full border border-brand-orange/30 bg-brand-orange/5 px-4 py-1.5 text-[11px] font-black uppercase tracking-[0.22em] text-brand-orange">
						<span
							className="relative inline-flex h-2 w-2"
							aria-hidden
						>
							<span className="absolute inline-flex h-full w-full rounded-full bg-brand-orange opacity-75 motion-safe:animate-ping" />
							<span className="relative inline-flex h-2 w-2 rounded-full bg-brand-orange" />
						</span>
						Em breve
					</span>

					<h2 className="mt-7 text-pretty text-3xl font-bold leading-[1.1] tracking-tight text-zinc-900 sm:text-4xl md:text-[2.65rem]">
						Suas dimensões de energia
						<br />
						<span className="text-brand-orange">
							estão a caminho
						</span>
					</h2>

					<p className="mt-5 max-w-xl text-pretty text-base leading-relaxed text-zinc-600 sm:text-lg">
						Estamos finalizando uma experiência personalizada para
						você mergulhar no seu bem-estar com mais profundidade.
						Em breve, suas dimensões aparecerão por aqui.
					</p>
				</div>
			</div>
		</div>
	);
};

export { FormEnergyDimensionsAnalyticsComingSoon };
